import * as React from 'react';

function SvgPlus(props) {
  return (
    <svg width={12} height={12} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path stroke="#38B2A6" strokeLinecap="round" d="M1.5 6h9M6 1.5v9" />
    </svg>
  );
}

export default SvgPlus;
